export default {
  SET_CONFIG: 'SET_CONFIG',
  SET_RESULTS: 'SET_RESULTS',
};
